import store from '../store/store';

export function isCalendarQuickComposeShown(): boolean {
    return store.moduleCommand === 'Open_QuickCompose';
}
